/**
 * @fileoverview POST handler for the "/apps/engagement_reports/campaigns_by_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsEngagementReportsCampaignsByTagsCacheKeys } from "./constants";
import type {
  PostAppsEngagementReportsCampaignsByTagsProps,
  AppsEngagementReportsCampaignsByTagsResult,
} from "./types";

export const postAppsEngagementReportsCampaignsByTags = reactQueryMutationAdapter(
  appsEngagementReportsCampaignsByTagsCacheKeys,
  (props: PostAppsEngagementReportsCampaignsByTagsProps): Promise<AppsEngagementReportsCampaignsByTagsResult> => {
    return fetch("/apps/engagement_reports/campaigns_by_tags", "POST", {
      app_group_id: props.appGroupId,
      tags: props.tags,
      tag_selector: props.tagSelector,
    });
  }
);
